import { Button, ConfigProvider, Form, Input, InputNumber, message, Modal, Select } from "antd";
import { Dispatch, Key, SetStateAction, useEffect, useState } from "react";
import container from "@/lib/di/container";
import React from "react";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { WaterInvoiceBasic, WaterInvoiceRepo } from "@/core/repos/tables/water-invoice.repo";
import { PaymentWithAccountantPayload, WaterInvoiceModel } from "@/core/models/water-invoice.model";
import { PaymentWithAccountantMethod } from "@/core/enums/global.enums";
import { paymentWithAccountantMethodPipe } from "@/core/pipes/pay-accountant-method.pipe";
import { currencyFormatter, formatCurrencyPipe, formatCurrencyPipeText } from "@/core/pipes/format-currency.pipe";
import { StaticDataTable } from "@/app/home/components/table/StaticDataTable";
import { approveStatusPipe } from "@/core/pipes/approve-status.pipe";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { invoiceStatusPipe, invoiceStatusTagsPipe } from "@/core/pipes/invoice-status.pipe";
import { paymentMethodPipe } from "@/core/pipes/payment-method-pipe";
import { cubicMeterPipe } from "@/core/pipes/unit.pipe";
import { MakeMultiAccPaymentModal } from "./MakeMultiAccPayment";
import { useUpdate } from "@/core/hooks/use-update.hook";

const waterInvoiceRepo = container.get(WaterInvoiceRepo);

interface PaymentWithAccountantMultiModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    query: any,
}

const INPUT_WIDTH = 450;

export const PaymentWithAccountantMultiModal: React.FC<PaymentWithAccountantMultiModalProps> = ({isModalOpen, setIsModalOpen, query}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingData, setLoadingData] = useState<boolean>(false);
    const [isNextModal, setNextModal] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<WaterInvoiceBasic[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
    const [data, setData] = useState<WaterInvoiceBasic[]>([]);

    // Attach hooks to handle data changes
    const handleDataChange = async () => {
        setLoadingData(true);
        const records = (await waterInvoiceRepo.getAllBasic(query)).map(r => ({...r, waterInvoiceStatus: invoiceStatusPipe(r.waterInvoiceStatus)}));
        setData(records);
        setSelectedRowKeys([]);
        setSelectedRows([]);
        setLoadingData(false);
    }
    useEffect(() => {
        handleDataChange();
    }, [query])

    useUpdate(() => {
        if (!isNextModal) {
            handleDataChange();
        }
    }, [isNextModal]);


    // Initialize select options data
    const init = async () => { }

    // componentDidMount equivalent, run exclusively on client-side
    useEffect(() => {init()}, []);

    const handleSave = async () => {
        try {
            if (selectedRows.length === 0) {
                message.error("Vui lòng chọn ít nhất một hóa đơn");
                return;
            }
            console.log(selectedRows);
            setNextModal(true);
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    };
    const handleCancel = () => {
        setSelectedRowKeys([]);
        setSelectedRows([]);
        setIsModalOpen(false);
        waterInvoiceRepo.refresh();
    };

    return (
        <ConfigProvider theme={MODAL_THEME}>
            <Modal open={isModalOpen} onCancel={handleCancel} width={1200} centered
            styles={{
                mask: {
                    backdropFilter: 'blur(2px)',
                    backgroundColor: 'var(--primary-mask)'
                }
            }}
            footer={[
                <div key={1} className="w-full flex flex-row justify-end px-1.5">
                    <Button key="submit" type="primary" loading={loading}
                        style={{ 
                            background: "var(--primary-color)", 
                            paddingRight: 48, 
                            paddingLeft: 48, 
                            fontSize: 18,
                            fontWeight: 600,
                            paddingTop: 18,
                            paddingBottom: 18,
                            }}
                        onClick={handleSave}
                    >
                        TIẾP TỤC
                    </Button>
                </div>,
            ]}>
                <div className="flex flex-row w-full items-start justify-start select-none">
                    <p className="ml-2 text-2xl font-bold text-primary">GẠCH NỢ NHIỀU HOÁ ĐƠN</p>
                </div>
                <div className="mt-[20px] mb-[10px]">
                    <StaticDataTable<WaterInvoiceBasic>
                        originalData={data}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        selectedRowKeys={selectedRowKeys}
                        setSelectedRowKeys={setSelectedRowKeys}
                        loading={loadingData}
                        columns={[
                            { name: "Tháng", pipe: (value: WaterInvoiceModel) => value.month + "/" + value.year, fixed: "left", width: 100 },
                            { name: "Số TC", dataIndex: "code" },
                            { name: "Mã KH", dataIndex: "waterUserCode" },
                            { name: "Tên KH", dataIndex: "waterUserName", width: 350 },
                            { name: "Tổng thanh toán", dataIndex: "total", pipe: formatCurrencyPipe },
                            { name: "TT Thanh toán", dataIndex: "waterInvoiceStatus", width: 150 },
                        ]}
                    />
                </div>
                <div className="mb-5 mx-2 border-t border-dashed border-gray-300"></div>
            </Modal>
            {isNextModal && <MakeMultiAccPaymentModal isModalOpen={isNextModal} setIsModalOpen={setNextModal} data={selectedRows} />}
        </ConfigProvider>
    )
}